import { getGroupPermissionFactory, PermissionEnum } from '../../../../common';
import { getLocationManagementModuleName } from './location-management.permissions';

export class DistrictsPermissions {
    static GroupName = `${getLocationManagementModuleName()}.Districts`;

    static getPermissions = getGroupPermissionFactory(DistrictsPermissions.GroupName);

    static Permissions = {
        Create: DistrictsPermissions.getPermissions(PermissionEnum.CREATE),
        Read: DistrictsPermissions.getPermissions(PermissionEnum.READ),
        ReadAll: DistrictsPermissions.getPermissions(PermissionEnum.READ_ALL),
        Update: DistrictsPermissions.getPermissions(PermissionEnum.UPDATE)
    };
}
